export default __webpack_public_path__ + "static/media/avatar_lion9.5cb20ad8.mp3";